import React from "react";
import CreateUser from "../components/ui/create-user";

const CreateUserPage = () => {
  return <CreateUser />;
};

export default CreateUserPage;
